import React, { useState, useContext, useEffect } from "react"
import { Col, Row } from "react-bootstrap"

import { CANDIDATE_SOCIAL_DATA_FETCH } from "../../components/candidate-profile/actions/socialAction"

import "./social.scss"
import SocialTag from "./social-tag"
import DeleteConfirmForm from "../../components/candidate-profile/form/delete-confirm"
import SocialInputForm from "./social-input"
import ModalComponent from "../../components/modal/modal"
import { GlobalAuthContext } from "../../context/authContext"
import Spinner from "../spinner/spinner"
import { COMPANY_SOCIAL_DATA_FETCH } from "../company-profile/actions/socialAction"

const Social = () => {
  const [social, setSocial] = useState([])

  const [addSocial, setAddSocial] = useState(false)

  const [showDeleteForm, setShowDeleteForm] = useState(false)

  const [id, setID] = useState(false)

  const [type, setType] = useState("")
  const [loading, setLoading] = useState(false)

  const [socialFormData, setSocialFormData] = useState({
    site: "",
    url: "",
  })
  const { state, dispatch } = useContext(GlobalAuthContext)

  const handleDeleteConfirmModalHide = (value, itemId, deleteType) => {
    setShowDeleteForm(value)
    if (itemId && deleteType) {
      setID(itemId)
      setType(deleteType)
    } else {
      setShowDeleteForm(false)
      setID(null)
    }
  }

  const handleSocialModalHide = (value, name, link) => {
    if (link !== undefined) {
      setAddSocial(value)

      let site = { name }
      setSocialFormData({
        ...socialFormData,
        disabled: true,
        site,
        url: link,
      })
    } else {
      setAddSocial(value)
      setSocialFormData({
        site: "",
        url: "",
      })
    }
  }
  useEffect(() => {
    if (state?.isAuthenticated && state?.user?.role === 2) {
      setLoading(true)
      CANDIDATE_SOCIAL_DATA_FETCH(
        state?.user?.id,
        dispatch,
        setSocial,
        setLoading
      )
    } else if (state?.isAuthenticated && state?.user?.role === 3) {
      COMPANY_SOCIAL_DATA_FETCH(dispatch, setSocial, setLoading)
    } else {
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Row className="align-items-center social ">
      <ModalComponent
        onHide={handleSocialModalHide}
        setShow={setAddSocial}
        show={addSocial}
      >
        <SocialInputForm
          social={social}
          setSocial={setSocial}
          setAddSocial={setAddSocial}
          socialFormData={socialFormData}
          setSocialFormData={setSocialFormData}
          disabled={socialFormData?.disabled}
        />
      </ModalComponent>

      <ModalComponent
        onHide={() => handleDeleteConfirmModalHide}
        setShow={handleDeleteConfirmModalHide}
        show={showDeleteForm}
      >
        <DeleteConfirmForm
          isCompany={state?.user?.role === 3}
          id={id}
          type={type}
          setData={setSocial}
          data={social}
          setShowDeleteForm={setShowDeleteForm}
        />
      </ModalComponent>
      <Col xs="1">
        <div className="d-flex align-items-center">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="mb-0">Social</label>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            aria-hidden="true"
            className="btn-custom plus br-0  blue text-center ml-1"
            onClick={() => handleSocialModalHide(true)}
          >
            +
          </a>
        </div>
      </Col>
      <Col xs="1" className="text-right "></Col>
      {/* <Col lg="12" className="border-top margin-hor-15px"></Col> */}
      {!loading ? (
        <Col lg="12">
          <div className="separator-border "></div>
          {Object.keys(social)?.length > 0 ? (
            <>
              <ul className="social-tags-container mt-3 d-block">
                {Object.keys(social)?.map(name => (
                  <SocialTag
                    key={name}
                    name={name}
                    link={social?.[name]}
                    editClick={handleSocialModalHide}
                    deleteClick={handleDeleteConfirmModalHide}
                  />
                ))}
              </ul>
            </>
          ) : (
            <div className="mb-4">Nothing to show.</div>
          )}
        </Col>
      ) : (
        <Spinner />
      )}
    </Row>
  )
}

export default Social
